import { connect } from 'react-redux'
import ExpCandidates from 'modules/Exp-Candidates/Components/index'
import driveSelector from 'modules/Exp-Candidates/selectors'

import authSelector from 'modules/Auth/selectors'
import { setDashboardNavs } from 'modules/Auth/actions'

import {
  getDriveListData,
  getIndidualDriveData,
  recreateCall,
  getCandidateScoreList,
  postShortlistCandidates,
  getTopicsList,
  postPassingScore,
} from 'modules/Exp-Candidates/actions'
import {
  getNewIndividualDriveStatus,
  getPanelList,
} from 'modules/Drives/actions'
const mapStateToProps = state => ({
  driveMetricsData: driveSelector.getDriveMetrics(state),

  dashboardNavs: authSelector.getDashboardNavs(state),maxCompensation
})
const mapDispatchToProps = {
  getDriveListData,
  getIndidualDriveData,
  setDashboardNavs,
  recreateCall,
  getCandidateScoreList,
  postShortlistCandidates,
  getTopicsList,
  postPassingScore,
  getNewIndividualDriveStatus,
  getPanelList,
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpCandidates)
